import pino from "pino";

const logger = pino({
  name: "Nualang App",
  level: "info",
});

export default logger;
